module.exports = __webpack_public_path__ + "public/images/play.658c07498f3f3a5f19b5dbf04b857348.svg";